// Generated by BUCKLESCRIPT VERSION 1.9.3, PLEASE EDIT WITH CARE
'use strict';

var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var Slide       = require("./slide");
var React       = require("react");
var Caml_array  = require("bs-platform/lib/js/caml_array.js");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/reasonReact.js");

((require('./app.css')));

var component = ReasonReact.reducerComponent("App");

function $$process(state, slides) {
  return $$Array.mapi((function (index, param) {
                return ReasonReact.element(/* None */0, /* None */0, Slide.make(param[0], +(state[/* active */1] === index), /* array */[param[1]]));
              }), slides);
}

function calculateCanvas(slides, active) {
  var match = Caml_array.caml_array_get(slides, active);
  var attributes = match[0];
  return /* record */[
          /* translate : record */[
            /* x */-attributes[/* translate */0][/* x */0] | 0,
            /* y */-attributes[/* translate */0][/* y */1] | 0,
            /* z */-attributes[/* translate */0][/* z */2] | 0
          ],
          /* rotate : record */[
            /* x */-attributes[/* rotate */1][/* x */0] | 0,
            /* y */-attributes[/* rotate */1][/* y */1] | 0,
            /* z */-attributes[/* rotate */1][/* z */2] | 0
          ]
        ];
}

function calculateScale(slides, active, config) {
  var h = window.innerHeight / config[/* height */1];
  var w = window.innerWidth / config[/* width */0];
  var match = +(h > w);
  var initial = match !== 0 ? w : h;
  var match$1 = Caml_array.caml_array_get(slides, active);
  return 1.0 / match$1[0][/* scale */2] * initial;
}

function makeTransformString(canvas) {
  return "rotateX(" + (Pervasives.string_of_int(canvas[/* rotate */1][/* x */0]) + ("deg) rotateY(" + (Pervasives.string_of_int(canvas[/* rotate */1][/* y */1]) + ("deg) rotateZ(" + (Pervasives.string_of_int(canvas[/* rotate */1][/* z */2]) + ("deg) translate3d(" + (Pervasives.string_of_int(canvas[/* translate */0][/* x */0]) + ("px," + (Pervasives.string_of_int(canvas[/* translate */0][/* y */1]) + ("px," + (Pervasives.string_of_int(canvas[/* translate */0][/* z */2]) + "px)")))))))))));
}

function make(slides, config, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      document.addEventListener("keydown", Curry._1(self[/* reduce */3], (function ($$event) {
                  $$event.preventDefault();
                  if (!self[/* state */4][/* transitioning */0][0]) {
                    setTimeout(Curry._1(self[/* reduce */3], (function () {
                                return /* AllowTransitioning */0;
                              })), 1250);
                  }
                  return /* KeyDown */[$$event.key];
                })));
      window.addEventListener("resize", Curry._1(self[/* reduce */3], (function () {
                  return /* Resize */1;
                })));
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var perspective = config[/* perspective */2] / self[/* state */4][/* scale */2];
      var transform = makeTransformString(self[/* state */4][/* canvas */3]);
      return React.createElement("section", {
                  style: {
                    left: "50%",
                    position: "absolute",
                    top: "50%",
                    transition: "all 750ms ease-in-out 125ms",
                    transform: "perspective(" + (Pervasives.string_of_float(perspective) + ("0px) scale(" + (Pervasives.string_of_float(self[/* state */4][/* scale */2]) + ")"))),
                    transformOrigin: "top left",
                    transformStyle: "preserve-3d"
                  }
                }, ReasonReact.createDomElement("section", {
                      style: {
                        position: "absolute",
                        transition: "all 1s ease-in-out 250ms",
                        transform: transform,
                        transformOrigin: "top left",
                        transformStyle: "preserve-3d"
                      }
                    }, $$process(self[/* state */4], slides)));
    });
  newrecord[/* initialState */10] = (function () {
      var canvas = calculateCanvas(slides, 0);
      var scale = calculateScale(slides, 0, config);
      return /* record */[
              /* transitioning */[/* false */0],
              /* active */0,
              /* scale */scale,
              /* canvas */canvas
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        if (action !== 0) {
          var scale = calculateScale(slides, 0, config);
          return /* Update */Block.__(0, [/* record */[
                      /* transitioning */state[/* transitioning */0],
                      /* active */state[/* active */1],
                      /* scale */scale,
                      /* canvas */state[/* canvas */3]
                    ]]);
        } else {
          state[/* transitioning */0][0] = /* false */0;
          return /* NoUpdate */0;
        }
      } else if (state[/* transitioning */0][0]) {
        return /* NoUpdate */0;
      } else {
        var key = action[0];
        if (key === " ") {
          var match = +(state[/* active */1] >= (slides.length - 1 | 0));
          var active = match !== 0 ? 0 : state[/* active */1] + 1 | 0;
          var canvas = calculateCanvas(slides, active);
          var scale$1 = calculateScale(slides, active, config);
          state[/* transitioning */0][0] = /* true */1;
          return /* Update */Block.__(0, [/* record */[
                      /* transitioning */state[/* transitioning */0],
                      /* active */active,
                      /* scale */scale$1,
                      /* canvas */canvas
                    ]]);
        } else if (key === "ArrowLeft") {
          var match$1 = +(state[/* active */1] === 0);
          var active$1 = match$1 !== 0 ? slides.length - 1 | 0 : state[/* active */1] - 1 | 0;
          var canvas$1 = calculateCanvas(slides, active$1);
          var scale$2 = calculateScale(slides, active$1, config);
          state[/* transitioning */0][0] = /* true */1;
          return /* Update */Block.__(0, [/* record */[
                      /* transitioning */state[/* transitioning */0],
                      /* active */active$1,
                      /* scale */scale$2,
                      /* canvas */canvas$1
                    ]]);
        } else if (key === "ArrowRight") {
          var match$2 = +(state[/* active */1] >= (slides.length - 1 | 0));
          var active$2 = match$2 !== 0 ? 0 : state[/* active */1] + 1 | 0;
          var canvas$2 = calculateCanvas(slides, active$2);
          var scale$3 = calculateScale(slides, active$2, config);
          state[/* transitioning */0][0] = /* true */1;
          return /* Update */Block.__(0, [/* record */[
                      /* transitioning */state[/* transitioning */0],
                      /* active */active$2,
                      /* scale */scale$3,
                      /* canvas */canvas$2
                    ]]);
        } else {
          return /* NoUpdate */0;
        }
      }
    });
  return newrecord;
}

exports.component           = component;
exports.$$process           = $$process;
exports.calculateCanvas     = calculateCanvas;
exports.calculateScale      = calculateScale;
exports.makeTransformString = makeTransformString;
exports.make                = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 20
// module chunks = 0